// import { Button } from '@components/index';
import { ReactElement } from 'react';
// import { useNavigate } from 'react-router-dom';

// import styles from './InstalmentStep2.module.scss';

function InstalmentStep2(): ReactElement {
  // const location = useLocation();
  // const navigate = useNavigate();

  // const navigateToNominationForm = () => {
  //   window.location.href = '/Nominate-a-driver/Nominate-a-driver/';
  // };
  // const handleContinueClick = () => {
  //   const url = '/Pay-by-instalments/Instalment-Form/step3';
  //   navigate(url);
  // };
  return (
    <>
      <div>
        <span className="vfH2">Have you nominated the person who was driving?</span>
        <br />
        <span className="subHeadingH3">
          You should{' '}
          <a href="https://online.fines.vic.gov.au/Nominate-a-driver/Nominate-a-driver/" target="_blank" rel="noreferrer">
            nominate the person who was driving
          </a>{' '}
          before applying for a payment arrangement.
        </span>
        {/* <span className="subHeadingH3">You should nominate the person who was driving before applying for a payment arrangement.</span> */}
        <br />
        {/* <br /> */}
        {/* <div className={styles.button_container}>
        <Button onClick={navigateToNominationForm} color="blue" size="medium">Nominate a driver</Button>
        <Button onClick={handleContinueClick} color="blue" size="medium">Continue</Button>
      </div> */}
      </div>
    </>
  );
}

export default InstalmentStep2;
